// extracted by mini-css-extract-plugin
export default {"container":"EmailQueueEmpty_container__DsGHJ","title":"EmailQueueEmpty_title__JB8Hv","description":"EmailQueueEmpty_description__nzjn8"};